"use strict";
/*
 *@description: 风险测评
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2021-03-25 08:56:36
 C1 - 保守型 C2 - 谨慎型 C3 - 稳健型 C4 - 积极型 C5 - 激进型
 *
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cepingDiff = exports.cmdTypeFun = exports.enterCePing = exports.subQuestionsCallback = exports.formatResultInfos = exports.subQuestions = exports.getQuestions = void 0;
var apidata_1 = require("../apidata");
var models_1 = __importDefault(require("./models"));
var commonapi_1 = require("../langke/commonapi"); //权限认证
var moment_1 = __importDefault(require("moment"));
/**
 * 白名单验证信息
 *
 * @returns
 */
function getAuthInfos(opt) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, newobj;
        return __generator(this, function (_a) {
            obj = {
                channel_id: urlid,
                password: "",
                view_type: 4,
                sn_token: ""
            };
            newobj = $.extend({}, obj, opt);
            return [2 /*return*/, (0, commonapi_1.generalValidate)(newobj)];
        });
    });
}
/**
 * if (type == 1 || type == 2) 提交按钮类型的时候 需提交 请求sn_token 提交给GeneralValidate权限接口
 * @param {(string|number)} channel_id
 */
function confirmNotice(channel_id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                return [2 /*return*/, (0, apidata_1.getLkApi)('api/PermissionAction/ConfirmNotice', { channel_id: channel_id })];
            }
            catch (error) {
                return [2 /*return*/, ""];
            }
            return [2 /*return*/];
        });
    });
}
/**
 * @export 获取问卷题目
 * @param {*}
 * @returns
 */
function getQuestions(qa_id) {
    return __awaiter(this, void 0, void 0, function () {
        var back, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    back = [];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, apidata_1.getLkApi)('api/QA/Info', { qa_id: qa_id })];
                case 2:
                    res = _a.sent();
                    if (res.result == 1 && (res === null || res === void 0 ? void 0 : res.data)) {
                        back = res.data;
                    }
                    ;
                    // 测评次数上限
                    if ((res === null || res === void 0 ? void 0 : res.result) == 6010) { //res.message
                        models_1.default.tipModel.init({
                            iconname: "cp_icon_upper",
                            cpinfos: "今日评测已达上限",
                            showcancelbtn: false
                        });
                    }
                    ;
                    return [2 /*return*/, back];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getQuestions = getQuestions;
;
/**
 * 提交问卷
 * @export
 * @param {*} subparams
 * @returns
 */
function subQuestions(subparams) {
    return __awaiter(this, void 0, void 0, function () {
        var paramstr;
        return __generator(this, function (_a) {
            paramstr = encodeURI(JSON.stringify(subparams));
            try {
                return [2 /*return*/, $.ajax({
                        type: 'GET',
                        url: "/api/subQuestions",
                        data: {
                            bodystr: paramstr
                        },
                        dataType: ""
                    })];
            }
            catch (error) {
                return [2 /*return*/, []];
            }
            return [2 /*return*/];
        });
    });
}
exports.subQuestions = subQuestions;
;
/**
 * 获取问卷结果对应的提示信息
 * C1 - 保守型 C2 - 谨慎型 C3 - 稳健型 C4 - 积极型 C5 - 激进型
 */
function formatResultInfos(res) {
    var back = {};
    if (!!res.re && (res === null || res === void 0 ? void 0 : res.result)) {
        var data = res === null || res === void 0 ? void 0 : res.result;
        var score = data === null || data === void 0 ? void 0 : data.score, level = data === null || data === void 0 ? void 0 : data.level, level_desc = data === null || data === void 0 ? void 0 : data.level_desc;
        var _resulttxt = 'C' + level + '-' + level_desc, _cptime = (0, moment_1.default)().format('YYYY-MM-DD'), _iconname = "";
        switch (level) {
            case 1:
                _iconname = "cp_icon_baoshou";
                break;
            case 2:
                _iconname = "cp_icon_jinshen";
                break;
            case 3:
                _iconname = "cp_icon_wenjian";
                break;
            case 4:
                _iconname = "cp_icon_jiji";
                break;
            case 5:
                _iconname = "cp_icon_jijin";
                break;
        }
        back = {
            _resulttxt: _resulttxt,
            _iconname: _iconname,
            _cptime: _cptime
        };
    }
    return back;
}
exports.formatResultInfos = formatResultInfos;
;
/**
 * 提交问卷后结果展示
 * @export
 * @param {*} res
 */
function subQuestionsCallback(res) {
    if (!!(res === null || res === void 0 ? void 0 : res.re) && (res === null || res === void 0 ? void 0 : res.result)) {
        var resinfos = formatResultInfos(res);
        models_1.default.resultModel.init({
            resulttxt: resinfos === null || resinfos === void 0 ? void 0 : resinfos._resulttxt,
            iconname: resinfos === null || resinfos === void 0 ? void 0 : resinfos._iconname,
            cptime: resinfos === null || resinfos === void 0 ? void 0 : resinfos._cptime,
            subcallback: function () {
                // 确认回调
            },
            subcallback2: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var authinfo;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAuthInfos({})];
                            case 1:
                                authinfo = _a.sent();
                                enterCePing(authinfo === null || authinfo === void 0 ? void 0 : authinfo.data);
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
    }
}
exports.subQuestionsCallback = subQuestionsCallback;
;
/**
 * 进入测评
 * @export
 */
function enterCePing(data) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var qa_id, questions, questionsLen;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    qa_id = data === null || data === void 0 ? void 0 : data.qa_id;
                    return [4 /*yield*/, getQuestions(qa_id)];
                case 1:
                    questions = _b.sent();
                    questionsLen = (_a = questions === null || questions === void 0 ? void 0 : questions.qa_config_set) === null || _a === void 0 ? void 0 : _a.length;
                    models_1.default.questionModel.init({
                        datalist: questions === null || questions === void 0 ? void 0 : questions.qa_config_set,
                        subcallback: function (ids) {
                            return __awaiter(this, void 0, void 0, function () {
                                var showtips, subparams;
                                return __generator(this, function (_a) {
                                    showtips = {};
                                    subparams = {
                                        id: qa_id,
                                        qa_answers: ids
                                    };
                                    //没有答完提示
                                    if (ids.length < questionsLen) {
                                        showtips = {
                                            iconname: "cp_icon_continu",
                                            cpinfos: "题目还未答完,请确认是否提交？",
                                            subbtntext: "继续答题",
                                            cancelbtntext: "仍要提交",
                                            showcancelbtn: true
                                        };
                                        // 没有任何选择
                                        if (ids.length == 0) {
                                            showtips.cpinfos = "题目还未答完，不可提交";
                                            showtips.showcancelbtn = false;
                                        }
                                        models_1.default.tipModel.init({
                                            iconname: showtips.iconname,
                                            cpinfos: showtips.cpinfos,
                                            subbtntext: showtips.subbtntext,
                                            cancelbtntext: showtips.cancelbtntext,
                                            showcancelbtn: showtips.showcancelbtn,
                                            subcallback2: function () {
                                                return __awaiter(this, void 0, void 0, function () {
                                                    var result;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, subQuestions(subparams)];
                                                            case 1:
                                                                result = _a.sent();
                                                                // console.log(result) 
                                                                subQuestionsCallback(result);
                                                                $("._cp_question_model").remove(); //移除问卷模块
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            }
                                        });
                                    }
                                    ;
                                    //答完提示
                                    if (ids.length == questionsLen) {
                                        showtips = {
                                            iconname: "cp_icon_submit",
                                            cpinfos: "确认提交",
                                            subbtntext: "提交",
                                            cancelbtntext: "取消",
                                        };
                                        models_1.default.tipModel.init({
                                            iconname: showtips.iconname,
                                            cpinfos: showtips.cpinfos,
                                            subbtntext: showtips.subbtntext,
                                            cancelbtntext: showtips.cancelbtntext,
                                            subcallback: function () {
                                                return __awaiter(this, void 0, void 0, function () {
                                                    var result;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, subQuestions(subparams)];
                                                            case 1:
                                                                result = _a.sent();
                                                                // console.log(result)
                                                                subQuestionsCallback(result);
                                                                $("._cp_question_model").remove(); //移除问卷模块
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            }
                                        });
                                    }
                                    ;
                                    return [2 /*return*/];
                                });
                            });
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.enterCePing = enterCePing;
;
/**
 *
 *  风险提示确认回调事件
 *  0 默认  1关闭弹窗 2关闭房间 3跳转(答题)
 * */
function cmdTypeFun(type, cbFun) {
    return __awaiter(this, void 0, void 0, function () {
        var authinfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(type == 3)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAuthInfos({})];
                case 1:
                    authinfo = _a.sent();
                    enterCePing(authinfo === null || authinfo === void 0 ? void 0 : authinfo.data);
                    return [2 /*return*/, false];
                case 2:
                    ;
                    if (type == 1 || type == 2) {
                        confirmNotice(urlid).then(function (res) {
                            var _a;
                            return __awaiter(this, void 0, void 0, function () {
                                var sn_token, authinfo, auth;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            sn_token = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.sn_token) || "";
                                            return [4 /*yield*/, getAuthInfos({ sn_token: sn_token })];
                                        case 1:
                                            authinfo = _b.sent();
                                            auth = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data;
                                            if (auth.code != 0 || type == 2) {
                                                //仅关闭弹窗等操作
                                            }
                                            ;
                                            if (auth.code == 0 && type == 1) {
                                                // 关闭弹窗 播放
                                                if (cbFun)
                                                    cbFun();
                                                $("#ly_mask_media").remove();
                                                $(".ly-vediobg-wrap").remove();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [2 /*return*/, false];
                    }
                    ;
                    return [2 /*return*/];
            }
        });
    });
}
exports.cmdTypeFun = cmdTypeFun;
;
//不同状态下的测评
exports.cepingDiff = {
    /**
     * 预告测评
     * @param {*} authinfo
     */
    yugaoCePing: function (authinfo, cbfun, closeCallback) {
        var _a, _b, _c, _d, _e, _f;
        var that = this;
        if (((_b = (_a = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _a === void 0 ? void 0 : _a.whitelist_config) === null || _b === void 0 ? void 0 : _b.whitelist_type) == 4) {
            var data = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data;
            var code = data === null || data === void 0 ? void 0 : data.code;
            var cmd_config_set = (_c = data === null || data === void 0 ? void 0 : data.notify_config) === null || _c === void 0 ? void 0 : _c.cmd_config_set;
            var sub1_1 = cmd_config_set === null || cmd_config_set === void 0 ? void 0 : cmd_config_set[0];
            var sub2 = cmd_config_set === null || cmd_config_set === void 0 ? void 0 : cmd_config_set[1]; //双选项
            var showcancel = (cmd_config_set === null || cmd_config_set === void 0 ? void 0 : cmd_config_set.length) > 1 ? true : false;
            // 43000跳转风险测评，会同时返回问卷ID
            if (code == 43000) {
                models_1.default.riskModel.init({
                    tiptext: "风险评测",
                    iconname: "cp_icon_evaluating",
                    cpinfos: (_d = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _d === void 0 ? void 0 : _d.notice,
                    showcancelbtn: showcancel,
                    cancelbtntxt: sub2 === null || sub2 === void 0 ? void 0 : sub2.cmd_text,
                    showsurebtn: true,
                    surebtntxt: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_text,
                    cmdtype: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_type,
                    subcallback2: function () {
                        enterCePing(authinfo === null || authinfo === void 0 ? void 0 : authinfo.data);
                    }
                });
            }
            ;
            //44000未确认风险
            if (code == 44000 || code == 43111) {
                models_1.default.riskModel.init({
                    tiptext: "风险提示",
                    iconname: "cp_icon_risknotice",
                    cpinfos: (_e = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _e === void 0 ? void 0 : _e.notice,
                    showcancelbtn: showcancel,
                    cancelbtntxt: sub2 === null || sub2 === void 0 ? void 0 : sub2.cmd_text,
                    showsurebtn: true,
                    surebtntxt: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_text,
                    cmdtype: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_type,
                    subcallback2: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: 
                                    // 根据接口返回的按钮 cmd_type  1 2 3  处理不同的回调
                                    return [4 /*yield*/, cmdTypeFun(sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_type, cbfun)];
                                    case 1:
                                        // 根据接口返回的按钮 cmd_type  1 2 3  处理不同的回调
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    },
                    closeCallback: function () {
                        closeCallback && closeCallback();
                    }
                });
            }
            ;
            // 43110
            if (code == 43110) {
                // 43110 测评不通过(风险不匹配) 
                var _icon = "cp_icon_matching";
                var _txt = "风险等级不匹配";
                models_1.default.riskModel.init({
                    tiptext: _txt,
                    iconname: _icon,
                    cpinfos: ((_f = authinfo === null || authinfo === void 0 ? void 0 : authinfo.data) === null || _f === void 0 ? void 0 : _f.notice) || "",
                    showcancelbtn: showcancel,
                    cancelbtntxt: sub2 === null || sub2 === void 0 ? void 0 : sub2.cmd_text,
                    showsurebtn: true,
                    surebtntxt: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_text,
                    cmdtype: sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_type,
                    subcallback2: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: 
                                    // 根据接口返回的按钮 cmd_type  1 2 3  处理不同的回调
                                    return [4 /*yield*/, cmdTypeFun(sub1_1 === null || sub1_1 === void 0 ? void 0 : sub1_1.cmd_type, cbfun)];
                                    case 1:
                                        // 根据接口返回的按钮 cmd_type  1 2 3  处理不同的回调
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                });
            }
            ;
        }
    },
    zhiboCePing: function (authinfo, zbcbFun, closeCallback) {
        this.yugaoCePing(authinfo, zbcbFun, closeCallback);
    },
    huiguCePing: function (authinfo, callback) {
        var hgcbFun = callback;
        this.yugaoCePing(authinfo, hgcbFun);
    }
};
//# sourceMappingURL=data:application/json;base64,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